import { useEffect } from "react";
import { useLocation } from "wouter";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useQueryClient } from "@tanstack/react-query";

export default function SubscriptionSuccess() {
  const [, setLocation] = useLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ['subscription', 'tier'] });
  }, [queryClient]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-12 max-w-md w-full text-center">
        <div className="bg-green-50 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="h-8 w-8 text-green-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Thanks for joining ClassTrack.</h1>
        <p className="text-gray-500 mb-8">
          Your account is being set up.
        </p>
        <Button className="w-full" onClick={() => setLocation("/app/dashboard")}>
          Go to dashboard
        </Button>
      </div>
    </div>
  );
}
